/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityBatchInfo = {
    BTNO: string;
    ST: HumanityBatchInfo.ST;
    AG: string;
    TRXCNT: string;
    MSGCNT: string;
    L1BLK: string;
    CMTRX: string;
    UT: number;
};

export namespace HumanityBatchInfo {

    export enum ST {
        FINALIZED = 'FINALIZED',
        UNFILALIZED = 'UNFILALIZED',
    }


}

